/**
 * Conversational ChatEvent types — events that represent an actual turn in the conversation
 * (a message, an answer, or a question, from agent / doctor / patient).
 *
 * Reaching any of these while scanning backward means the conversation has moved on, so any
 * earlier unanswered question is no longer the one the user is being asked to answer right now.
 * Everything NOT listed here is a technical / lifecycle / system event (AGENT_BUSY, AGENT_START,
 * AGENT_STEP, AGENT_COMPLETE, CHAT_START, CHAT_END, STAFF_JOIN, PROFILE_DATA_*, SUBSCRIPTION_*,
 * SIDE_EFFECTS) that can be emitted asynchronously while a response is awaited and must NOT
 * invalidate a pending question.
 */
const CONVERSATIONAL_EVENT_TYPES = new Set([
    'PATIENT_MESSAGE',
    'PATIENT_FORM',
    'PATIENT_ANSWER',
    'AGENT_MESSAGE',
    'AGENT_FORM',
    'AGENT_QUESTION',
    'AGENT_SUMMARY',
    'AGENT_DONE',
    'STAFF_PROMPT',
    'STAFF_MESSAGE',
    'STAFF_ANSWER',
]);
export function getPendingAgentMessage(events, options = {}) {
    const { target, step, includeMessages = false, inputType } = options;
    for (let i = events.length - 1; i >= 0; i--) {
        const event = events[i];
        if (!CONVERSATIONAL_EVENT_TYPES.has(event.type)) {
            continue;
        }
        if (event.type === 'AGENT_QUESTION' &&
            (target == null || event.target === target) &&
            (step == null || event.step === step) &&
            (inputType == null || event.input.type === inputType)) {
            return event;
        }
        if (includeMessages &&
            event.type === 'AGENT_MESSAGE' &&
            (target == null || event.target === target) &&
            (step == null || event.step === step)) {
            return event;
        }
        return undefined;
    }
    return undefined;
}
//# sourceMappingURL=getPendingAgentMessage.js.map